<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MsotAddMain from "@/views/StockManagement/MsotManage/TabChild/MsotAddMain";

export default {
  name: "MsotAdd",
  components: {
    childTab1: MsotAddMain
  },
  data() {
    return {
      activeName: "first",
    }
  },
}
</script>

<style scoped>

</style>